import { apiClient } from './client';
import type { Envelope, PageMeta, HealthRecord, ListRecordsParams } from './types';

export type CreateRecordInput = {
  recordDate: string;
  heightCm?: string | null;
  weightKg?: string | null;
  categoryId?: number | null;
  metrics?: Record<string, unknown>;
  notes?: string | null;
};

export type UpdateRecordInput = Partial<CreateRecordInput>;

export async function listRecords(params: ListRecordsParams = {}): Promise<{ data: HealthRecord[]; meta: PageMeta }> {
  const res = await apiClient.get<Envelope<HealthRecord[]> & { meta: PageMeta }>('/records', { params });
  return { data: res.data.data, meta: res.data.meta };
}

export async function getRecord(id: number): Promise<HealthRecord> {
  const res = await apiClient.get<Envelope<HealthRecord>>(`/records/${id}`);
  return res.data.data;
}

export async function createRecord(input: CreateRecordInput): Promise<HealthRecord> {
  const res = await apiClient.post<Envelope<HealthRecord>>('/records', input);
  return res.data.data;
}

export async function updateRecord(id: number, input: UpdateRecordInput): Promise<HealthRecord> {
  const res = await apiClient.patch<Envelope<HealthRecord>>(`/records/${id}`, input);
  return res.data.data;
}

export async function deleteRecord(id: number): Promise<void> {
  await apiClient.delete(`/records/${id}`);
}

export async function bulkDeleteRecords(ids: number[]): Promise<number> {
  const res = await apiClient.post<Envelope<{ deleted: number }>>('/records/bulk-delete', { ids });
  return res.data.data.deleted;
}
